import { coreTranslator } from './translators/core';
import {
  createDocumentDomainHook,
  createDomainUpdateHook,
} from './domainHookFactory';
import type { CoreSettings } from './types';

export const useCoreSettings = createDocumentDomainHook<CoreSettings>(
  'core',
  coreTranslator,
);

export const useUpdateCoreSettings =
  createDomainUpdateHook<CoreSettings>(useCoreSettings);
